import Model from '@/store/model';
import Pricing from './pricing';
import CorrectAnswerPricing from './correct_answer_pricing';
import TestGrammarPricing from './test_grammar_pricing';
import User from '../user/user';
import SkillRewards from './skill_rewards';
import GrammarReferences from './grammar_references';
import AlliableFriends from './alliable_friends';
import Chatbot from './chatbot';
import ExpressionResponse from './expression_response';
import ExpressionTest from './expression_test';
import LessonContent from './lesson_content';
import Asset from './asset';
import MonsterInfo from './monster_info';

class LessonResponse extends Model {
  map(json) {
    super.map(json);

    if (json.pricing !== undefined && json.pricing !== null) {
      this.pricing = new Pricing();
      this.pricing.map(json.pricing);
    }

    if (json.correct_answer_pricing !== undefined && json.correct_answer_pricing !== null) {
      this.correctAnswerPricing = new CorrectAnswerPricing();
      this.correctAnswerPricing.map(json.correct_answer_pricing);
    }

    if (json.test_grammar_pricing !== undefined && json.test_grammar_pricing !== null) {
      this.testGrammarPricing = new TestGrammarPricing();
      this.testGrammarPricing.map(json.test_grammar_pricing);
    }

    if (json.skill_rewards !== undefined && json.skill_rewards !== null) {
      this.skillRewards = new SkillRewards();
      this.skillRewards.map(json.skill_rewards);
    }

    if (json.grammar_references !== undefined && json.grammar_references !== null) {
      this.mapArray('grammarReferences', json.grammar_references, GrammarReferences);
    }

    if (json.friends !== undefined && json.friends !== null) {
      this.mapArray('friends', json.friends, User);
    }

    if (json.alliable_friends !== undefined && json.alliable_friends !== null) {
      this.alliableFriends = new AlliableFriends();
      this.alliableFriends.map(json.alliable_friends);
    }

    if (json.chatbot !== undefined && json.chatbot !== null) {
      this.chatbot = new Chatbot();
      this.chatbot.map(json.chatbot);
    }
    if (json.expressions !== undefined && json.expression !== null) {
      this.mapArray('expressions', json.expressions, ExpressionResponse);
    }
    if (json.expression_tests !== undefined && json.expression_tests !== null) {
      this.mapArray('expressionTests', json.expression_tests, ExpressionTest);
    }
    if (json.tests !== undefined && json.tests !== null) {
      this.mapArray('tests', json.tests, ExpressionTest);
    }
    if (json.contents !== undefined && json.contents !== null) {
      this.mapArray('contents', json.contents, LessonContent);
    }
    if (json.assets !== undefined && json.assets !== null) {
      this.mapArray('assets', json.assets, Asset);
    }
    if (json.monster_info !== undefined && json.monster_info !== null) {
      this.monsterInfo = new MonsterInfo();
      this.monsterInfo.map(json.monster_info);
    }
  }

  isBonusLesson() {
    return this.lessonType === LessonResponse.BONUS_LESSON;
  }
  isGrammar() {
    return this.lessonType === LessonResponse.GRAMMAR_LESSON_TYPE;
  }
  isExpressionLearner() {
    return this.lessonType === LessonResponse.EXPRESSION_LEARNER_LESSON_TYPE;
  }
}
LessonResponse.BONUS_LESSON = 'bonus_lesson'
LessonResponse.GRAMMAR_LESSON_TYPE = 'grammar';
LessonResponse.EXPRESSION_LEARNER_LESSON_TYPE = 'expression_learner';

export default LessonResponse;
